<template>
  <div class="before_login-wrap">登录中...</div>
</template>
<script>
import axios from '../../http';
import { mapMutations } from 'vuex';
import * as as from 'axios';

export default {
  name: 'before_login',
  components: {},
  props: {},
  data() {
    return {
      re: '',
      code: '',
      urlToken: '',
      theme: '', // 链接的特定id = nonghe ,代表是在农合app内
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.re = this.getUrlParam('register_code');
    this.code = this.getUrlParam('token');
    this.urlToken = this.getUrlParam('code');
    this.theme = this.getUrlParam('theme');

    if (this.theme == 'nonghe') {
      this.getTheme(this.theme);
    } else {
      this.getTheme('');
    }

    if (this.urlToken) {
      as.post(`${process.env.VUE_APP_TOKEN_URL}/token`, {
        client_id: 'air',
        grant_type: 'authorization_code',
        code: this.urlToken,
        scope: '',
        redirect_uri: window.location.origin,
      }).then((res) => {
        console.log('res', res);
        let token = res.data.access_token;
        // alert(token);

        if (res.status == 200) {
          this.getToken(res.data.access_token);
          axios.fetchPost('/member/center/member', { token: token }).then((res) => {
            let data = res.data;
            if (data.code == 200) {
              this.getUserAvatar(res.data.data.avatar);
              this.getUserName(res.data.data.nickname);
              this.getUserPhone(res.data.data.mobile);
              this.setUserType(res.data.data.user_type);
              // this.getToken(res.data.data.token);
              if (res.data.data.user_type == 1) {
                setTimeout(() => {
                  this.$router.push({
                    path: '/secondBar/medication',
                  });
                }, 500);
              } else if (res.data.data.user_type == 0) {
                setTimeout(() => {
                  this.$router.push({
                    path: '/identity',
                    query: { token: token },
                  });
                }, 500);
              } else {
                this.$router.replace({
                  path: '/notFarmer',
                });
              }
            } else if (res.data.code == 211) {
              this.$router.push({
                path: '/identity',
                query: { token: token },
              });
            }
          });
        } else {
          this.$router.push({
            path: '/login',
          });
        }
      });
      return;
    } else if (this.getIsWxClient()) {
      if (this.re) {
        this.$router.replace({
          path: '/bindPhone',
          query: { register_code: this.re },
        });
        return;
      } else if (this.code) {
        // this.getUserInfo();
        this.getToken(this.code);
        let token = this.code;
        axios.fetchPost('/member/center/member', { token: token }).then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.getUserAvatar(res.data.data.avatar);
            this.getUserName(res.data.data.nickname);
            this.getUserPhone(res.data.data.mobile);
            this.setUserType(res.data.data.user_type);
            // this.getToken(res.data.data.token);
            if (res.data.data.user_type == 1) {
              setTimeout(() => {
                this.$router.push({
                  path: '/secondBar/medication',
                });
              }, 500);
            } else if (res.data.data.user_type == 0) {
              setTimeout(() => {
                this.$router.push({
                  path: '/identity',
                  query: { token: token },
                });
              }, 500);
            } else {
              this.$router.replace({
                path: '/notFarmer',
              });
            }
          } else if (res.data.code == 211) {
            this.$router.push({
              path: '/identity',
              query: { token: token },
            });
          }
        });

        // alert(this.code);
        return;
      } else {
        // 跳转去微信授权
        window.location.href =
          `${process.env.VUE_APP_URL}/wechat/index/login?return_url=` +
          encodeURIComponent(process.env.VUE_APP_WEIXIN_URL);
      }
    } else {
      this.$router.push({
        path: '/login',
      });
      return;
    }
  },
  destroyed() {},
  methods: {
    ...mapMutations([
      'getUserAvatar',
      'getUserName',
      'getUserPhone',
      'getToken',
      'getTheme',
      'setUserType',
    ]),
    getUrlParam(name) {
      //构造一个含有目标参数的正则表达式对象
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      // console.log('window.location.search', window.location.search);
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null; //返回参数值
      }
    },
    getIsWxClient() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
      } else {
        return false;
      }
    },
    getUserInfo() {
      //  获取用户信息
      axios
        .fetchPost('/member/center/member', { token: this.code })
        .then((res) => {
          let data = res.data;
          if (data.code == 200) {
            this.getUserAvatar(res.data.data.avatar);
            this.getUserName(res.data.data.nickname);
            this.getUserPhone(res.data.data.mobile);
            this.getToken(res.data.data.token);
          } else if (res.data.code == 211) {
            this.$router.push({
              path: '/identity',
              query: { token: this.code },
            });
          }
        })
        .catch();
    },
  },
};
</script>
<style lang="stylus" scoped></style>
